"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[562],{

/***/ 83900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgArrowDown = function SvgArrowDown(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 256,
        height: 256,
        viewBox: "0 0 256 256"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        d: "M0 66.73c0 2.66.981 5.33 2.955 7.41l117.332 123.323a10.64 10.64 0 0 0 7.712 3.314c2.912 0 5.696-1.19 7.712-3.314L253.043 74.14c4.074-4.278 3.914-11.077-.331-15.163a10.627 10.627 0 0 0-15.083.333L128 174.536 18.379 59.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76 10.76 0 0 0 0 66.73"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowDown);


/***/ }),

/***/ 10562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ features_table_pricing_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services/ab-tests/monetization-ab-tests-service.js + 2 modules
var monetization_ab_tests_service = __webpack_require__(46724);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./services/pricing/plans-service.js
var plans_service = __webpack_require__(56492);
// EXTERNAL MODULE: ./services/pricing-features-service.js + 1 modules
var pricing_features_service = __webpack_require__(97169);
// EXTERNAL MODULE: ./services/bigbrain-service.js + 1 modules
var bigbrain_service = __webpack_require__(95470);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./constants/pricing-sizes.js
var pricing_sizes = __webpack_require__(42349);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing-features-section/pricing-features-section.scss.js


var StyledPricingFeaturesSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ec0s3110"
})(".header{padding:12px 0;border-bottom:", "1px solid ".concat(colors/* default.border-gray */.Z["border-gray"]), ";&:focus > .section-name{outline:initial;}.section-name{outline:none;font-weight:500;font-size:1.375rem;line-height:24px;letter-spacing:-0.361538px;margin:unset;// default styles for h3 add 1em margin}}.features-list{margin-top:12px;display:flex;flex-direction:column;.feature{display:flex;.feature-name{font-size:0.875rem;line-height:24px;}}}");

// EXTERNAL MODULE: ./static/svg/pricing-info-icon.svg
var pricing_info_icon = __webpack_require__(89046);
// EXTERNAL MODULE: ./components/enhancements/tooltip/tooltip-component.js + 1 modules
var tooltip_component = __webpack_require__(31590);
// EXTERNAL MODULE: ./components/enhancements/tooltip/tooltip-constants.js
var tooltip_constants = __webpack_require__(24984);
;// CONCATENATED MODULE: ./services/pricing/pricing-page/features-service.js
var getFeatureInfoElementID = function(featureName, sectionName, index) {
    var featureNameParts = featureName.split("."); // feature name is something like "pricingPage.features.titles.whiteboard"
    var featureActualName = featureNameParts[featureNameParts.length - 1];
    if (featureName.endsWith(".alt")) {
        // some features have alternative texts in a test, so they get two keys, the second ending with ".alt"
        featureActualName = featureNameParts[featureNameParts.length - 2]; // one part before the "alt"
    }
    return "featureInfo_".concat(featureActualName, "_").concat(sectionName, "_").concat(index); // adding 'index' on the offchance that the same feature appears twice in a section.
};

// EXTERNAL MODULE: ./services/pricing/pricing-page/pricing-page-display-service.js
var pricing_page_display_service = __webpack_require__(60004);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing-features-section/components/feature-component/feature-component.scss.js



var StyledFeatureComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ejenw7c0"
})("display:flex;width:100%;&:first-child{.feature-name,.plan-feature-component{padding-top:14px;}}&:last-child{.feature-name,.plan-feature-component{padding-bottom:8px;}}.feature-name{display:flex;align-items:center;min-height:48px;position:relative;padding:0 16px;padding-left:0;&:first-child{border-color:", colors/* default.dark-marble */.Z["dark-marble"], ";}.feature-name-text{font-size:0.844rem;font-weight:400;line-height:20px;margin:-8px 16px 0 0;padding:10px 0;flex-grow:1;}}.feature-info{cursor:pointer;position:relative;svg{width:16px;height:16px;pointer-events:none;}path{fill:", colors/* default.asphalt */.Z.asphalt, ";}.feature-tooltip-container{position:relative;z-index:", z_index/* MODAL_BACKGROUND */.AE, ";display:none;opacity:0;position:absolute;bottom:calc(100% + 16px);transform:translateX(-50%);transition:opacity 0.2s ease;width:300px;.floating-tooltip{position:relative;white-space:normal;text-align:left;}}&.tooltip-active{.feature-tooltip-container{opacity:1;display:block;}}&:hover{.feature-tooltip-container{opacity:1;display:block;}}}");

// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
;// CONCATENATED MODULE: ./static/svg/pricing-check.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgPricingCheck = function SvgPricingCheck(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        viewBox: "0 0 16 16"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#40C870",
        fillRule: "evenodd",
        d: "M7.547 15.964a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m-1.085-3.953 4.797-4.798A.999.999 0 1 0 9.845 5.8L6.472 9.172 4.759 7.435A.999.999 0 1 0 3.335 8.84z"
    })));
};
/* harmony default export */ var pricing_check = (SvgPricingCheck);

;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing-features-section/components/feature-component/plan-feature-value/plan-feature-value-component.scss.js




var StyledPlanFeatureValueComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yiwl4i0"
})("display:flex;justify-content:center;align-items:center;padding-right:16px;padding-left:16px;border:none;position:relative;&.disabled{cursor:default;}&:last-child{border-right:none;border-color:", colors/* default.dark-marble */.Z["dark-marble"], ";}.plan-feature-name{font-size:0.8125rem;font-weight:400;text-align:center;}.plan-feature-info{position:absolute;margin-left:8px;left:calc(50% + 8px);&.with-string-value{position:relative;left:0;top:2px;}.plan-feature-info-tooltip-container{z-index:", z_index/* MODAL_BACKGROUND */.AE, ";display:none;opacity:0;position:absolute;bottom:calc(100% + 16px);transform:translateX(-50%);.floating-tooltip{position:relative;}}transition:opacity 0.2s ease;&:hover{.plan-feature-info-tooltip-container{opacity:1;display:block;}}}.check-circle{font-size:0.875rem;color:red;position:relative;&.free{path{fill:", plans_service/* TIERS_COLORS_MAP.free.tierContentColor */.f_.free.tierContentColor, ";}}&.basic{path{fill:", plans_service/* TIERS_COLORS_MAP.basic.tierContentColor */.f_.basic.tierContentColor, ";}}&.standard{path{fill:", plans_service/* TIERS_COLORS_MAP.standard.tierContentColor */.f_.standard.tierContentColor, ";}}&.pro{path{fill:", plans_service/* TIERS_COLORS_MAP.pro.tierContentColor */.f_.pro.tierContentColor, ";}}&.enterprise{path{fill:", plans_service/* TIERS_COLORS_MAP.enterprise.tierContentColor */.f_.enterprise.tierContentColor, ";}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing-features-section/components/feature-component/plan-feature-value/plan-feature-value-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}











var isObject = function(value) {
    return typeof value === "object" && value !== null;
};
var PlanFeatureValueComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PlanFeatureValueComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PlanFeatureValueComponent);
    function PlanFeatureValueComponent(props) {
        (0,_class_call_check/* default */.Z)(this, PlanFeatureValueComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getFeatureValueCellID", function() {
            var _props = _this.props, tier = _props.tier, featureName = _props.featureName, indexInSection = _props.indexInSection;
            return "featureTierValue_".concat(featureName.replace(/\./g, "_"), "_").concat(tier, "_").concat(indexInSection);
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getBooleanValueString", function(value) {
            var translate = _this.props.translate;
            return value ? translate("pricingPage.included") : translate("pricingPage.notIncluded");
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getFeatureAriaLabel", function() {
            var _props = _this.props, plan = _props.plan, featureValue = _props.featureValue, featureName = _props.featureName, translate = _props.translate;
            var displayName = plan.displayName;
            var value = isString_default()(featureValue) ? translate(featureValue) : _this.getBooleanValueString(featureValue);
            return "".concat(translate(displayName), ": ").concat(translate(featureName), ". ").concat(value, ".");
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(PlanFeatureValueComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // setting the 'aria-label' value to either the cell itself, or the checkmark SVG within it.
                var featureValue = this.props.featureValue;
                if (featureValue === true) {
                    // value is a boolean true, i.e. a checkmark is rendered
                    (0,accessibility_service/* setSVGTitle */.B3)("#".concat(this.getFeatureValueCellID()), this.getFeatureAriaLabel());
                } else {
                    document.getElementById(this.getFeatureValueCellID()).setAttribute("aria-label", this.getFeatureAriaLabel());
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, tier = _props.tier, featureValue = _props.featureValue, featureInfo = _props.featureInfo, translateOrTranslateWithParam = _props.translateOrTranslateWithParam, planWidth = _props.planWidth;
                var planFeatureStyle = {
                    width: "".concat(planWidth, "%")
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPlanFeatureValueComponent, {
                    id: this.getFeatureValueCellID(),
                    className: classnames_default()("plan-feature-value-component", tier),
                    onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                    role: "cell",
                    style: planFeatureStyle,
                    children: [
                        featureValue === true && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("check-circle ".concat(tier)),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_check, {})
                        }),
                        (isString_default()(featureValue) || isObject(featureValue)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "plan-feature-name",
                            children: translateOrTranslateWithParam(featureValue)
                        }),
                        featureInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("plan-feature-info", {
                                "with-string-value": isString_default()(featureValue)
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_info_icon/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "plan-feature-info-tooltip-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_component/* default */.Z, {
                                        theme: tooltip_constants.DARK_THEME,
                                        className: "floating-tooltip",
                                        children: translateOrTranslateWithParam(featureInfo)
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return PlanFeatureValueComponent;
}(react.PureComponent);
/* harmony default export */ var plan_feature_value_component = ((0,generic_config_context/* withGenericConfig */.P)(PlanFeatureValueComponent));

;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing-features-section/components/feature-component/feature-component.js





function feature_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}















var FeatureComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FeatureComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FeatureComponent);
    function FeatureComponent(props) {
        (0,_class_call_check/* default */.Z)(this, FeatureComponent);
        var _this;
        _this = _super.call(this, props);
        feature_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getFeatureInfoID", function() {
            var _props = _this.props, featureName = _props.featureName, indexInSection = _props.indexInSection, sectionName = _props.sectionName;
            return getFeatureInfoElementID(featureName, sectionName, indexInSection);
        });
        feature_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "shouldTrackVisibilityForFeature", function() {
            var onVisible = _this.props.onVisible;
            return !!onVisible;
        });
        feature_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onFeatureVisibilityChange", function(isVisible) {
            if (!isVisible) return;
            var _props = _this.props, onVisible = _props.onVisible, abTests = _props.abTests, forcePricing = _props.forcePricing;
            var isAlreadyVisible = _this.state.isAlreadyVisible;
            var onVisibleCallback = onVisible.callback, onlyOnce = onVisible.onlyOnce;
            if (isAlreadyVisible && onlyOnce) return;
            onVisibleCallback({
                abTests: abTests,
                forcePricing: forcePricing
            });
            _this.setState({
                isAlreadyVisible: true
            });
        });
        feature_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onTooltipFocus", function() {
            _this.onMouseEnterToInfoIcon();
            _this.setState({
                tooltipActive: true
            });
        });
        feature_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onTooltipBlur", function() {
            _this.setState({
                tooltipActive: false
            });
        });
        _this.onMouseEnterToInfoIcon = _this.onMouseEnterToInfoIcon.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.state = {
            isAlreadyVisible: false,
            tooltipActive: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(FeatureComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, translateOrTranslateWithParam = _props.translateOrTranslateWithParam, featureDescription = _props.featureDescription;
                (0,accessibility_service/* setSVGTitle */.B3)("#".concat(this.getFeatureInfoID()), translateOrTranslateWithParam(featureDescription));
            }
        },
        {
            key: "onMouseEnterToInfoIcon",
            value: function onMouseEnterToInfoIcon() {
                var _props = this.props, featureName = _props.featureName, translate = _props.translate, clusterId = _props.clusterId;
                BigBrain("track", bigbrain_event_types.PRICING_PAGE_FEATURE_INFO_ICON_HOVER, {
                    placement: "homepage_minisite",
                    kind: featureName,
                    info1: translate(featureName),
                    info3: clusterId
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, featureValuesPerPlan = _props.featureValuesPerPlan, featureName = _props.featureName, featureDescription = _props.featureDescription, plans = _props.plans, translate = _props.translate, translateOrTranslateWithParam = _props.translateOrTranslateWithParam, indexInSection = _props.indexInSection;
                var tooltipActive = this.state.tooltipActive;
                var pricingDimensions = (0,pricing_page_display_service/* getPricingDimensions */.K)(plans);
                var featuresSectionDimensions = pricingDimensions.featuresSection;
                var featureWidth = featuresSectionDimensions.featureWidth, planWidth = featuresSectionDimensions.planWidth;
                var featureNameStyle = {
                    width: "".concat(featureWidth, "%")
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                    partialVisibility: true,
                    onChange: this.onFeatureVisibilityChange,
                    active: this.shouldTrackVisibilityForFeature(),
                    scrollCheck: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeatureComponent, {
                        className: "feature-component",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "feature-name",
                                onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                                role: "cell",
                                style: featureNameStyle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "feature-name-text",
                                        children: translate(featureName)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()("feature-info", {
                                            "tooltip-active": tooltipActive
                                        }),
                                        id: this.getFeatureInfoID(),
                                        onMouseEnter: this.onMouseEnterToInfoIcon,
                                        tabIndex: 0,
                                        onFocus: this.onTooltipFocus,
                                        onBlur: this.onTooltipBlur,
                                        onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                                        "aria-label": translateOrTranslateWithParam(featureDescription),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_info_icon/* default */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "feature-tooltip-container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_component/* default */.Z, {
                                                    theme: tooltip_constants.DARK_THEME,
                                                    className: "floating-tooltip",
                                                    children: translateOrTranslateWithParam(featureDescription)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            plans.map(function(plan) {
                                var tier = plan.tier;
                                var _tier = featureValuesPerPlan[tier], value = _tier.value, info = _tier.info;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(plan_feature_value_component, {
                                    plan: plan,
                                    tier: tier,
                                    featureValue: value,
                                    featureInfo: info,
                                    featureName: featureName,
                                    indexInSection: indexInSection,
                                    planWidth: planWidth
                                }, tier);
                            })
                        ]
                    }, featureName)
                });
            }
        }
    ]);
    return FeatureComponent;
}(react.PureComponent);
/* harmony default export */ var feature_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(FeatureComponent)));

;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing-features-section/default-props.js
/* harmony default export */ var default_props = ({});

;// CONCATENATED MODULE: ./segments/desktop/core-components/pricing-features-section/pricing-features-section.js










var PricingFeaturesSection = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PricingFeaturesSection, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PricingFeaturesSection);
    function PricingFeaturesSection() {
        (0,_class_call_check/* default */.Z)(this, PricingFeaturesSection);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PricingFeaturesSection, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, section = _props.section, translate = _props.translate, plans = _props.plans, sectionHeaderID = _props.sectionHeaderID;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPricingFeaturesSection, {
                    className: "pricing-features-section",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header",
                            role: "row",
                            tabIndex: 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "section-name",
                                role: "rowheader",
                                id: sectionHeaderID,
                                children: translate(section.sectionName)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "features-list",
                            role: "rowgroup",
                            "aria-labelledby": sectionHeaderID,
                            children: section.features.map(function(feature, index) {
                                var name = feature.name, description = feature.description, id = feature.id, onVisible = feature.onVisible;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "feature",
                                    role: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feature_component, {
                                        plans: plans,
                                        featureName: name,
                                        featureDescription: description,
                                        featureValuesPerPlan: feature.tiers,
                                        onVisible: onVisible,
                                        featureId: id,
                                        indexInSection: index,
                                        sectionName: section.sectionName
                                    }, name)
                                }, name);
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return PricingFeaturesSection;
}(react.PureComponent);
/* harmony default export */ var pricing_features_section = ((0,generic_config_context/* withGenericConfig */.P)(PricingFeaturesSection));
PricingFeaturesSection.defaultProps = default_props;

// EXTERNAL MODULE: ./static/svg/arrow-down.svg
var arrow_down = __webpack_require__(83900);
// EXTERNAL MODULE: ./segments/desktop/core-components/pricing-action-button/pricing-action-button.js + 2 modules
var pricing_action_button = __webpack_require__(66713);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-service.js + 31 modules
var base_header_service = __webpack_require__(43787);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/features-table-pricing/features-table/sticky-table-header/sticky-table-header-component.scss.js




var StyledStickyTableHeaderComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14g16hw0"
})("display:flex;justify-content:space-between;position:sticky;top:", pricing_sizes/* TIERS_STICKY_HEADER_OFFSET */.$D + "px", ";transition:top 100ms ease;align-items:center;z-index:1;background-color:white;&.with-border{border-bottom:", "1px solid ".concat(colors/* default.border-gray */.Z["border-gray"]), ";}/* fix for the minisite pricing pages upwards scrolling */\n  &.scrolling-upwards-minisite{top:", "".concat(pricing_sizes/* TIERS_STICKY_HEADER_OFFSET */.$D + constants/* default.SECONDARY_HEADER_HEIGHT */.Z.SECONDARY_HEADER_HEIGHT, "px"), ";}.pick-your-plan-text{font-weight:bold;font-size:1.575rem;line-height:28px;letter-spacing:-0.361538px;align-self:center;padding-top:12px;}.tier-section{display:flex;flex-direction:column;align-items:center;.tier-name{padding-top:4px;font-weight:600;font-size:1rem;}.tier-button{padding:12px 0;.signup-button-wrapper{button.signup-button.ladda-button{padding:8px 16px;}}button.pricing-contact-us-button.xs.ladda-button{margin-top:0;padding:8px 16px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/features-table-pricing/features-table/sticky-table-header/sticky-table-header-component.js





function sticky_table_header_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}









var StickyTableHeaderComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(StickyTableHeaderComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(StickyTableHeaderComponent);
    function StickyTableHeaderComponent(props) {
        (0,_class_call_check/* default */.Z)(this, StickyTableHeaderComponent);
        var _this;
        _this = _super.call(this, props);
        sticky_table_header_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "stickyScrollingHandler", function() {
            var isClusterMiniSitePage = _this.props.isClusterMiniSitePage;
            if (!isClusterMiniSitePage) return; // no need to modify the top position if we're not scrolling.
            setTimeout(function() {
                _this.setState({
                    shouldIncreaseStickyTopPosition: (0,base_header_service/* isDesktopMinisiteSecondaryMenuActive */.EH)()
                });
            }, 0); // we want this to happen after any other setState-s.
        });
        _this.state = {
            shouldIncreaseStickyTopPosition: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(StickyTableHeaderComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var isClusterMiniSitePage = this.props.isClusterMiniSitePage;
                if (isClusterMiniSitePage) {
                    window.addEventListener("scroll", this.stickyScrollingHandler, {
                        passive: true
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var isClusterMiniSitePage = this.props.isClusterMiniSitePage;
                if (isClusterMiniSitePage) {
                    window.removeEventListener("scroll", this.stickyScrollingHandler);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, plans = _props.plans, translateOrTranslateWithParam = _props.translateOrTranslateWithParam, hasBorder = _props.hasBorder;
                var shouldIncreaseStickyTopPosition = this.state.shouldIncreaseStickyTopPosition;
                var pricingDimensions = (0,pricing_page_display_service/* getPricingDimensions */.K)(plans);
                var featuresSectionDimensions = pricingDimensions.featuresSection;
                var featureWidth = featuresSectionDimensions.featureWidth, planWidth = featuresSectionDimensions.planWidth;
                var sectionNameStyle = {
                    width: "".concat(featureWidth, "%")
                };
                var planNameStyle = {
                    width: "".concat(planWidth, "%")
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStickyTableHeaderComponent, {
                    className: classnames_default()("sticky-table-header-container", {
                        "with-border": hasBorder,
                        "scrolling-upwards-minisite": shouldIncreaseStickyTopPosition
                    }),
                    role: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pick-your-plan-text",
                            role: "columnheader",
                            style: sectionNameStyle
                        }),
                        plans.map(function(plan) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tier-section",
                                style: planNameStyle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tier-name",
                                        style: {
                                            color: (0,plans_service/* getPlanColor */.kP)(plan, true)
                                        },
                                        role: "columnheader",
                                        children: translateOrTranslateWithParam(plan.displayName)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tier-button",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_action_button/* default */.Z, {
                                            plan: plan,
                                            placement: "features-table-sticky-header",
                                            signupButtonText: translateOrTranslateWithParam("signup.tryForFree"),
                                            contactUsButtonText: translateOrTranslateWithParam("footer.contactUs")
                                        })
                                    })
                                ]
                            }, plan.tier);
                        })
                    ]
                });
            }
        }
    ]);
    return StickyTableHeaderComponent;
}(react.PureComponent);
/* harmony default export */ var sticky_table_header_component = ((0,generic_config_context/* withGenericConfig */.P)(StickyTableHeaderComponent));

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/features-table-pricing/features-table/features-table-component.scss.js


var StyledFeaturesTableComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1k81jw20"
})("display:flex;flex-direction:column;.see-complete-feature-list-container{display:flex;justify-content:center;align-items:center;margin:24px;cursor:pointer;.see-complete-feature-list-button{margin-left:16px;margin-top:0;transition:transform 0.3s,margin 0.1s;transition-timing-function:ease-in-out;transform:rotate(180deg);svg{width:24px;height:24px;}}&.list-hidden{.see-complete-feature-list-button{transform:rotate(0);margin-top:8px;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){/* This table is not meant to be shown on smaller screens. \n            Until an alternative display is designed - if that happens - we just hide it altogether. */\n    display:none;}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/features-table-pricing/features-table/features-table-component.js





function features_table_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
















var FeaturesTableComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FeaturesTableComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FeaturesTableComponent);
    function FeaturesTableComponent(props) {
        (0,_class_call_check/* default */.Z)(this, FeaturesTableComponent);
        var _this;
        _this = _super.call(this, props);
        features_table_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "onVisibilityChange", function(isSeen) {
            _this.setState({
                hasBorder: !isSeen
            });
        });
        features_table_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "getSectionHeaderId", function(sectionName) {
            return "featuresSection_".concat(sectionName);
        });
        features_table_component_define_property((0,_assert_this_initialized/* default */.Z)(_this), "toggleFeaturesList", function() {
            var clusterId = _this.props.clusterId;
            var newValue = !_this.state.shouldSeeFeaturesList;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.SEE_COMPLETE_FEATURES_LIST_CLICKED, {
                info1: newValue ? "shown" : "hidden",
                placement: "homepage_minisite",
                kind: clusterId
            });
            _this.setState({
                shouldSeeFeaturesList: !_this.state.shouldSeeFeaturesList
            });
        });
        _this.state = {
            shouldSeeFeaturesList: false,
            hasBorder: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(FeaturesTableComponent, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, translateOrTranslateWithParam = _props.translateOrTranslateWithParam, abTests = _props.abTests, forcePricing = _props.forcePricing, hasFreeTier = _props.hasFreeTier, hasStudentPlan = _props.hasStudentPlan, cookies = _props.cookies, ignoreClusterConfig = _props.ignoreClusterConfig;
                var ref = ignoreClusterConfig ? {
                    clusterConfig: {},
                    clusterId: undefined
                } : this.props, clusterConfig = ref.clusterConfig, clusterId = ref.clusterId;
                var params = {
                    hasStudentPlan: hasStudentPlan,
                    hasFreeTier: hasFreeTier,
                    abTests: abTests,
                    cookies: cookies,
                    clusterId: clusterId,
                    clusterConfig: clusterConfig,
                    forcePricing: forcePricing
                };
                var plans = (0,plans_service/* getPlans */.qY)(params);
                var tableSections = (0,pricing_features_service/* getPlanFeatures */.uI)(params);
                var _state = this.state, hasBorder = _state.hasBorder, shouldSeeFeaturesList = _state.shouldSeeFeaturesList;
                var featuresListButtonTitleText = shouldSeeFeaturesList ? "pricingPage.hideCompleteFeaturesList" : "pricingPage.seeCompleteFeaturesList";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFeaturesTableComponent, {
                    className: "features-table-component",
                    role: "table",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("see-complete-feature-list-container", {
                                "list-hidden": !shouldSeeFeaturesList
                            }),
                            role: "button",
                            title: translateOrTranslateWithParam(featuresListButtonTitleText),
                            onClick: this.toggleFeaturesList,
                            onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                            onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(this.toggleFeaturesList),
                            tabIndex: 0,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "see-complete-feature-list-text",
                                    children: translateOrTranslateWithParam("pricingPage.completeFeaturesList")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "see-complete-feature-list-button",
                                    "aria-hidden": true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down/* default */.Z, {})
                                })
                            ]
                        }),
                        shouldSeeFeaturesList && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_table_header_component, {
                                    plans: plans,
                                    hasBorder: hasBorder
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                                    offset: {
                                        top: pricing_sizes/* TIERS_STICKY_HEADER_BORDER_OFFSET */.ld
                                    },
                                    onChange: this.onVisibilityChange,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tiers-sticky-header-visibility-checkpoint"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "features-list-sections",
                                    children: tableSections.map(function(section) {
                                        var sectionName = section.sectionName;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "section-container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_features_section, {
                                                section: section,
                                                plans: plans,
                                                sectionHeaderID: _this.getSectionHeaderId(sectionName)
                                            })
                                        }, sectionName);
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return FeaturesTableComponent;
}(react.PureComponent);
/* harmony default export */ var features_table_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(FeaturesTableComponent)));

// EXTERNAL MODULE: ./constants/pricing.js
var pricing = __webpack_require__(55674);
// EXTERNAL MODULE: ./segments/desktop/pricing/product-pricing-config.js
var product_pricing_config = __webpack_require__(69535);
// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_component = __webpack_require__(20776);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./services/pricing/pricing-page/contact-us-link-service.js
var contact_us_link_service = __webpack_require__(4442);
// EXTERNAL MODULE: ./segments/desktop/pricing/icons/product-icon.js + 4 modules
var product_icon = __webpack_require__(68988);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/features-table-pricing/product-features-table/product-features-table-section/product-features-table-feature/product-features-table-feature.scss.js


var StyledProductFeatureName = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emem2b50"
})("display:flex;justify-content:space-between;align-items:center;padding:", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing ? "24px 0" : "16px 0";
}, ";color:#676879;justify-content:space-between;font-weight:400;font-size:0.844rem;border-bottom:", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing ? "1px solid #C3C6D4" : "none";
}, ";.icon{position:relative;margin-left:6px;.tooltip{z-index:", z_index/* MODAL_BACKGROUND */.AE, ";display:none;opacity:0;position:absolute;bottom:calc(100% + 16px);transform:translateX(-50%);transition:opacity 0.2s ease;width:300px;.floating-tooltip{position:relative;white-space:normal;text-align:left;top:100%;left:50%;}}&:hover{.tooltip{display:block;opacity:1;}}}");
var StyledProductFeatureValue = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "emem2b51"
})("font-size:0.875rem;display:flex;justify-content:center;align-items:center;text-align:center;padding:16px 0;border-bottom:", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing ? "1px solid #C3C6D4" : "none";
}, ";&.check-circle{path{fill:#676879;}}&.empty-feature-value{border-bottom:", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing ? "1px solid #C3C6D4" : "none";
}, ";}");

;// CONCATENATED MODULE: ./static/svg/new-pricing-check.svg
var new_pricing_check_path;
function new_pricing_check_extends() {
    new_pricing_check_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return new_pricing_check_extends.apply(this, arguments);
}

var SvgNewPricingCheck = function SvgNewPricingCheck(props) {
    return /*#__PURE__*/ react.createElement("svg", new_pricing_check_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        fill: "none",
        viewBox: "0 0 21 21"
    }, props), new_pricing_check_path || (new_pricing_check_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#676879",
        d: "M8.049 15.041a.75.75 0 0 0 1.06 0l7.718-7.717a.75.75 0 0 0-1.06-1.061L8.578 13.45 5.11 9.98a.75.75 0 1 0-1.06 1.061z"
    })));
};
/* harmony default export */ var new_pricing_check = (SvgNewPricingCheck);

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/features-table-pricing/product-features-table/product-features-table-section/product-features-table-feature/product-features-table-feature.js














var isLimitNumeric = function(limit) {
    return !isNaN(limit);
};
var ProductFeaturesTableFeature = function(param) {
    var productName = param.productName, feature = param.feature, hideFreeTier = param.hideFreeTier, hasFreeTier = param.hasFreeTier, isNewPricing = param.isNewPricing, shouldHideBasicTier = param.shouldHideBasicTier;
    var featureName = feature.featureName, tierColumnValues = feature.tierColumnValues;
    var translate = (0,react.useContext)(generic_config_context/* GenericConfigContext */.Z).translate;
    var product = product_pricing_config/* default */.Z[productName];
    var productFeatureName = (0,pricing_features_service/* translateProductKeyFallbackToCore */.nO)({
        productName: productName,
        key: featureName
    });
    var productFeatureDescription = (0,pricing_features_service/* translateProductKeyFallbackToCore */.nO)({
        productName: productName,
        key: "".concat(featureName, ".description")
    });
    var getProductTiers = (0,react.useCallback)(function() {
        var tiers = (0,_to_consumable_array/* default */.Z)(product.tiers);
        if (!hasFreeTier || hideFreeTier) {
            tiers = tiers.filter(function(tier) {
                return tier.name !== pricing/* TIERS.FREE */.Iy.FREE;
            });
        }
        if (shouldHideBasicTier) {
            tiers = tiers.filter(function(tier) {
                return tier.name !== pricing/* TIERS.BASIC */.Iy.BASIC;
            });
        }
        return tiers;
    }, [
        hasFreeTier,
        hideFreeTier,
        product,
        shouldHideBasicTier
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductFeatureName, {
                className: "feature-name",
                isNewPricing: isNewPricing,
                children: [
                    productFeatureName,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "icon",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tooltip",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tooltip_component/* default */.Z, {
                                    theme: tooltip_constants.DARK_THEME,
                                    className: "floating-tooltip",
                                    children: [
                                        " ",
                                        productFeatureDescription
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_info_icon/* default */.Z, {})
                        ]
                    })
                ]
            }),
            getProductTiers().map(function(tier) {
                var value = tierColumnValues[tier.name];
                if (value === true) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductFeatureValue, {
                        className: classnames_default()("feature-value", "check-circle"),
                        isNewPricing: isNewPricing,
                        children: isNewPricing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(new_pricing_check, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_check, {})
                    });
                }
                if (value === undefined || value === null) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductFeatureValue, {
                        className: classnames_default()("feature-value", "check-circle"),
                        isNewPricing: isNewPricing,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "empty-feature-value"
                        })
                    });
                }
                if (typeof value === "object" && value.limit) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductFeatureValue, {
                        className: "feature-value",
                        isNewPricing: isNewPricing,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "bold",
                                children: isLimitNumeric(value.limit) ? parseInt(value.limit).toLocaleString() : translate(value.limit)
                            }),
                            "\xa0",
                            translate(value.description)
                        ]
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductFeatureValue, {
                    className: "feature-value",
                    isNewPricing: isNewPricing,
                    children: translate(value)
                });
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/features-table-pricing/product-features-table/product-features-table-section/product-features-table-section.scss.js

var StyledProductFeaturesTableSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1wr11sz0"
})("text-align:left;display:flex;justify-content:flex-start;padding:12px 0px;border-bottom:1px ", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing ? "solid #C3C6D4" : "solid rgb(230, 233, 239)";
}, ";grid-column:1/-1;&.feature-section-name ~ .feature-section-name{margin-top:", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing ? "70px" : "inherit";
}, ";}h3{margin:0;font-weight:", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing ? 600 : 700;
}, ";letter-spacing:", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing ? -0.1 : 0.361538;
}, "px;font-size:", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing ? 20 : 16;
}, "px;padding:", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing ? "24px 0" : "inherit";
}, ";}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/features-table-pricing/product-features-table/product-features-table-section/product-features-table-section.js




var ProductFeaturesTableSection = function(param) {
    var productName = param.productName, productSection = param.productSection, hideFreeTier = param.hideFreeTier, hasFreeTier = param.hasFreeTier, isNewPricing = param.isNewPricing, shouldHideBasicTier = param.shouldHideBasicTier;
    var sectionName = productSection.sectionName, features = productSection.features;
    var productSectionName = (0,pricing_features_service/* translateProductKeyFallbackToCore */.nO)({
        productName: productName,
        key: "sections.".concat(sectionName)
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            sectionName && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductFeaturesTableSection, {
                className: "feature-section-name",
                isNewPricing: isNewPricing,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    children: productSectionName
                })
            }),
            features.map(function(feature) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFeaturesTableFeature, {
                    productName: productName,
                    feature: feature,
                    hideFreeTier: hideFreeTier,
                    hasFreeTier: hasFreeTier,
                    isNewPricing: isNewPricing,
                    shouldHideBasicTier: shouldHideBasicTier
                }, feature.featureName);
            })
        ]
    });
};

// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/features-table-pricing/product-features-table/product-features-table.scss.js


var StyledProductFeaturesTable = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1qojr210"
})("display:flex;flex-direction:column;.toggle{cursor:pointer;display:flex;justify-content:center;align-items:center;padding:16px 0;svg{margin-left:8px;height:12px;width:12px;transition:all 0.5s;}&.expanded{margin-bottom:", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing ? "64px" : "inherit";
}, ";svg{transform:rotate(-180deg);}}}.grid{grid-template-columns:", function(param) {
    var numberOfTiers = param.numberOfTiers;
    return "1.6fr repeat(".concat(numberOfTiers, ",1fr)");
}, ";display:grid;.feature-value,.tier-header{display:flex;justify-content:center;align-items:center;padding:16px 0;&.tier-header{background-color:white;position:sticky;top:73px;display:flex;flex-direction:column;z-index:2;.tier-title{font-size:", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing ? "20px" : "1rem";
}, ";font-weight:600;margin-bottom:16px;", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing && "\n            display: flex;\n            flex-direction: column;\n            gap: 8px;\n            align-items: center;\n          ";
}, "}}.bold{font-weight:600;}.tier-cta{position:sticky;top:72px;.ladda-button,.signup-button,.cta-button{padding:12px ", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing ? "43px" : "24px";
}, ";background-color:transparent;border:1px solid black;color:black;letter-spacing:0.4px;font-size:16px;&:hover{border-color:transparent;background-color:", function(param) {
    var isNewPricing = param.isNewPricing;
    return isNewPricing ? "#323338" : "var(--primary-color)";
}, ";color:white;}}}}.product-section-header{display:flex;align-items:center;grid-column:1 / 3;margin-bottom:18px;.icon-container{text-align:left;justify-content:flex-start;display:flex;border-radius:12px;width:38px;height:38px;justify-content:center;align-items:center;padding:6px;background-color:var(--logo-color);}.product-name{margin-left:8px;font-size:16px;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){/* This table is not meant to be shown on smaller screens. \n            Until an alternative display is designed - if that happens - we just hide it altogether. */\n    display:none;}");

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/features-table-pricing/product-features-table/product-features-table.js



















var ProductFeaturesTable = function(param) {
    var currentProductName = param.productName, isExpandedProp = param.isExpanded, setIsExpandedProp = param.setIsExpanded, abTests = param.abTests, hideFreeTier = param.hideFreeTier, hasFreeTier = param.hasFreeTier, isNewPricing = param.isNewPricing, shouldHideBasicTier = param.shouldHideBasicTier;
    var currentProduct = product_pricing_config/* default */.Z[currentProductName];
    var translate = (0,react.useContext)(generic_config_context/* GenericConfigContext */.Z).translate;
    var ref = (0,react.useState)(false), localIsExpanded = ref[0], setLocalIsExpanded = ref[1];
    var controlledMode = setIsExpandedProp !== undefined;
    var setIsExpanded = controlledMode ? setIsExpandedProp : setLocalIsExpanded;
    var isExpanded = controlledMode ? isExpandedProp : localIsExpanded;
    var toggleFeaturesList = (0,react.useCallback)(function() {
        var newToggleValue = !isExpanded;
        setIsExpanded(newToggleValue);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SEE_COMPLETE_FEATURES_LIST_CLICKED, {
            info1: newToggleValue ? "shown" : "hidden",
            productKind: currentProductName,
            button_name: "dropdown_features_list_pricing_page"
        });
    }, [
        setIsExpanded,
        isExpanded
    ]);
    var isFeatureListEmpty = (0,react.useCallback)(function() {
        var product = product_pricing_config/* default */.Z[currentProductName];
        if (!product || !product.featuresList) {
            return true;
        }
        return product.featuresList.length === 0;
    }, []);
    var getTiers = (0,react.useCallback)(function() {
        if (!hasFreeTier || hideFreeTier) {
            return currentProduct.tiers.filter(function(tier) {
                return tier.name !== pricing/* TIERS.FREE */.Iy.FREE;
            });
        }
        return currentProduct.tiers;
    }, [
        currentProduct,
        hasFreeTier,
        hideFreeTier
    ]);
    var handleBeforeSubmitCallback = function(tierName) {
        (0,cookies_service/* setCookie */.d8)(cookies.HOMEPAGE_PRICING_TIER_SOURCE, "".concat(currentProductName, "-").concat(tierName));
    };
    var productName = translate("pricingPage.products.".concat(currentProductName, ".longTitleBold"));
    var featuresList = isNewPricing ? currentProduct.newFeaturesList : currentProduct.featuresList;
    var filteredTiers = shouldHideBasicTier ? getTiers().filter(function(tier) {
        return tier.name !== pricing/* TIERS.BASIC */.Iy.BASIC;
    }) : getTiers();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductFeaturesTable, {
        className: "product-features-table",
        isNewPricing: isNewPricing,
        numberOfTiers: filteredTiers.length,
        role: "table",
        style: {
            "--primary-color": currentProduct.primaryColor,
            "--secondary-color": currentProduct.secondaryColor,
            "--logo-color": currentProduct.switcherIconColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("toggle", {
                    expanded: isExpanded
                }),
                onClick: function() {
                    return toggleFeaturesList();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: translate("pricingPage.completeFeaturesList")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down/* default */.Z, {
                        className: "arrow-down"
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tier-header"
                    }),
                    filteredTiers.map(function(tier) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tier-header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tier-title",
                                    children: translate((0,plans_service/* getTierTranslationKey */.OU)(tier.name, {
                                        hasStudentPlan: false
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tier-cta",
                                    children: tier.name !== pricing/* TIERS.ENTERPRISE */.Iy.ENTERPRISE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                        buttonSize: "xs",
                                        extraData: {
                                            pricing_tier: tier.name,
                                            cta_name: "full_feature_list",
                                            productKind: currentProductName
                                        },
                                        beforeSubmitCallback: function() {
                                            return handleBeforeSubmitCallback(tier === null || tier === void 0 ? void 0 : tier.name);
                                        },
                                        useCtaText: isNewPricing,
                                        ctaText: isNewPricing ? translate("signup.tryForFree") : null,
                                        className: isNewPricing ? "tier-cta-button" : undefined
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.Z, {
                                        type: "button",
                                        buttonSize: "xs",
                                        onClickCallback: function() {
                                            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CONTACT_US_BUTTON_CLICKED, {
                                                info1: "enterprise",
                                                placement: "feature_list"
                                            });
                                            window.location.href = (0,contact_us_link_service/* getPricingContactUsLink */.p)(abTests);
                                        },
                                        children: translate("footer.contactSales")
                                    })
                                })
                            ]
                        }, "tier-header-".concat(tier.name));
                    }),
                    !isFeatureListEmpty() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-section-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "icon-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_icon/* ProductIcon */.w, {
                                    product: "".concat(currentProductName, "White"),
                                    className: "product-section-logo"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "product-name",
                                dangerouslySetInnerHTML: {
                                    __html: productName
                                }
                            })
                        ]
                    }),
                    !isFeatureListEmpty() && (featuresList === null || featuresList === void 0 ? void 0 : featuresList.map(function(productSection) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductFeaturesTableSection, {
                            productSection: productSection,
                            productName: currentProductName,
                            hideFreeTier: hideFreeTier,
                            hasFreeTier: hasFreeTier,
                            isNewPricing: isNewPricing,
                            shouldHideBasicTier: shouldHideBasicTier
                        }, productSection.sectionName);
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ var product_features_table = ((0,ab_tests_context/* withAbTests */.k)(ProductFeaturesTable));

;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/features-table-pricing/features-table-pricing-component.scss.js


var StyledFeaturesTablePricingComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "esgewnk0"
})("width:", "".concat(pricing_sizes/* PLANS_COMPONENT_WIDTH */.pP, "px"), ";margin:0 auto;");

// EXTERNAL MODULE: ./services/pricing-service.js + 2 modules
var pricing_service = __webpack_require__(15650);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
;// CONCATENATED MODULE: ./segments/desktop/pricing/layouts/features-table-pricing/features-table-pricing-component.js




function features_table_pricing_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            features_table_pricing_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var FeaturesTablePricingComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FeaturesTablePricingComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FeaturesTablePricingComponent);
    function FeaturesTablePricingComponent(props) {
        (0,_class_call_check/* default */.Z)(this, FeaturesTablePricingComponent);
        var _this;
        _this = _super.call(this, props);
        _this.checkIfShouldSeeProductsFeaturesTable();
        return _this;
    }
    (0,_create_class/* default */.Z)(FeaturesTablePricingComponent, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.checkIfShouldSeeProductsFeaturesTable();
            }
        },
        {
            key: "checkIfShouldSeeProductsFeaturesTable",
            value: function checkIfShouldSeeProductsFeaturesTable() {
                var _props = this.props, productName = _props.productName, abTests = _props.abTests, clusterId = _props.clusterId, hasStudentPlan = _props.hasStudentPlan, cookies = _props.cookies, forcePricing = _props.forcePricing, cloudfrontViewerCountry = _props.cloudfrontViewerCountry, isClusterMiniSitePage = _props.isClusterMiniSitePage;
                this.shouldSeeProductsFeaturesTable = productName && (isClusterMiniSitePage || (0,monetization_ab_tests_service/* shouldSeeProductsPricingPage */.GV)({
                    abTests: abTests,
                    clusterId: clusterId,
                    hasStudentPlan: hasStudentPlan,
                    cookies: cookies,
                    forcePricing: forcePricing,
                    cloudfrontViewerCountry: cloudfrontViewerCountry
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, ignoreClusterConfig = _props.ignoreClusterConfig, isHomepagePricing = _props.isHomepagePricing, clusterId = _props.clusterId, abTests = _props.abTests, simulateNewPricingTest = _props.simulateNewPricingTest, productName = _props.productName, persistantCookies = _props.persistantCookies, forceSunsetBasic = _props.forceSunsetBasic;
                // When productize handle the case that product name not always match to cluster, it works for CRM but for core not
                var isNewPricing = simulateNewPricingTest && productName === clusters.CRM || this.props.isNewPricing || (0,pricing_service/* shouldSeeNewPricing */.RW)(productName, abTests);
                // the full feature list
                var hideBasicTier = (0,pricing_service/* shouldHideBasicTier */.K$)({
                    persistantCookies: persistantCookies,
                    clusterId: clusterId,
                    productName: productName,
                    abTests: abTests,
                    forceSunsetBasic: forceSunsetBasic
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFeaturesTablePricingComponent, {
                    className: "features-table-pricing-component",
                    children: this.shouldSeeProductsFeaturesTable || isHomepagePricing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(product_features_table, _object_spread_props(_object_spread({}, this.props), {
                        isNewPricing: isNewPricing,
                        shouldHideBasicTier: hideBasicTier
                    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(features_table_component, {
                        ignoreClusterConfig: ignoreClusterConfig
                    })
                });
            }
        }
    ]);
    return FeaturesTablePricingComponent;
}(react.PureComponent);
/* harmony default export */ var features_table_pricing_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(FeaturesTablePricingComponent)));


/***/ })

}]);